module.exports = __webpack_public_path__ + "img/home-hover.0e6119e1.svg";